import { bodySmallStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const SectionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['04']};
`

export const EmptyTimelineMessage = styled.p`
  ${bodySmallStyles};
  margin: 0;
  color: ${({ theme }) => theme.color.content.subtle};
`
